<template>
  <div class="playback-controls flex">
    <div class="flex-none w-6 text-left">
      <button @click="switchPlaybackState()" class="text-sm p-4 py-2 pl-0 active:text-gray-500 hover:text-gray-550 flex-none border-0">
          <font-awesome-icon v-if="play === false" icon="fa-solid fa-play" />
          <font-awesome-icon v-if="play === true" icon="fa-solid fa-stop" />
      </button>
    </div>

    <div class="flex-none text-left text-xs py-2 mt-px">
      <!-- Time Elapsed / Total Duration -->
      <span v-html="timeElapsed" /> / <span v-html="totalDuration" />
    </div>

    <div class="grow py-2 pl-3">
      <el-progress class="mt-[6px]" :color="progressColor" :percentage="percentage" :define-back-color="backColor" :show-text="false"></el-progress>
    </div>
  </div>
</template>

<script src="./project-template-playback-controls.js"></script>
<style lang="scss" src="./project-template-playback-controls.scss"></style>
